import { createSelector } from 'reselect';

import {
  // Features
  featuresIsCampusProminentPositionSelector,
  featuresIsCampusNormalPositionSelector,
  // Frame
  hasUserSelector,
  // Navigation
  navigationCampusSelector,
  navigationJobsSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
  navigationServicesSelector,
} from '../../../selectors';

export default createSelector(
  hasUserSelector,
  featuresIsCampusProminentPositionSelector,
  featuresIsCampusNormalPositionSelector,
  navigationCampusSelector,
  navigationJobsSelector,
  navigationEventsSelector,
  navigationContentSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationBusinessSelector,
  navigationServicesSelector,
  (
    hasUser,
    isCampusProminentPosition,
    isCampusNormalPosition,
    campus,
    jobs,
    events,
    content,
    groups,
    companies,
    business,
    services
  ) => {
    const campusProminent = isCampusProminentPosition && campus;
    const campusNormal =
      !isCampusProminentPosition && isCampusNormalPosition && campus;

    return hasUser
      ? [
          campusProminent,
          jobs,
          events,
          content,
          groups,
          companies,
          campusNormal,
          business,
          services,
        ].filter(Boolean)
      : null;
  }
);
